import { useEffect } from 'react';

const useWarnRefresh = () => {
    useEffect(() => {
        const handler = (event: BeforeUnloadEvent) => {
            event.returnValue = 'Changes you made will not be saved.';
            event.preventDefault();
            }
        window.addEventListener('beforeunload', handler);
        return () => {
          window.removeEventListener('beforeunload', handler);
        };
    }, []);
}

export default useWarnRefresh;